// import Swiper, { Navigation } from "swiper";
// Swiper.use([Navigation]);
// document.querySelectorAll(".ImageCarousel").forEach((ImageCarousel) => {
//   const imageList = ImageCarousel.querySelector(".ImageCarousel__images");
//   if (imageList) {
//     new Swiper(imageList as HTMLElement, {
//       slidesPerView: 1,
//       spaceBetween: 20,
//       navigation: {
//         nextEl: ".swiper-slide-next",
//         prevEl: ".swiper-slide-prev",
//       },
//       loop: true,
//       speed: 300,
//       grabCursor: true,
//     });
//   }
// });

// import Swiper, { Pagination, Navigation } from "swiper";
// var swiper = new Swiper(".mySwiper", {
// 	pagination: {
// 	  el: ".swiper-pagination",
// 	},
//   });

import Swiper, { Pagination, Navigation } from "swiper";
Swiper.use([Pagination, Navigation]);

document.querySelectorAll(".ImageCarousel").forEach((ImageCarousel) => {
  const interestingImageList = ImageCarousel.querySelector(
    ".interesting__container.ImageCarousel__images"
  );
  if (interestingImageList) {
    const carousel = new Swiper(interestingImageList as any, {
      slidesPerView: 1, //"auto",
      spaceBetween: 42,
      // navigation: {
      //   // TODO: this is not working properly, using workaround buttons
      //   nextEl: ".swiper-button-next",
      //   prevEl: ".swiper-button-prev",
      // },
      a11y: {},
      // autoHeight: true,
      loop: false,
      speed: 300,
      pagination: {
        el: ".swiper-pagination",
        dynamicBullets: true,
        clickable: true,
      },
      grabCursor: true,
    });
  }

  const showRealImageList = ImageCarousel.querySelector(
    ".showreal__container.ImageCarousel__images"
  );
  if (showRealImageList) {
    const carousel = new Swiper(showRealImageList as any, {
      slidesPerView: "auto",
      spaceBetween: 24,
      // autoHeight: true,
      loop: false,
      speed: 300,
      grabCursor: true,
    });
  }

  const memberImageList = ImageCarousel.querySelector(
    ".MemberslistSlider__container.ImageCarousel__images"
  );
  if (memberImageList) {
    const carousel = new Swiper(memberImageList as any, {
      slidesPerView: "auto",
      spaceBetween: 24,
      // autoHeight: true,
      loop: false,
      speed: 300,
      grabCursor: true,
    });
  }
});

// document.querySelectorAll(".ImageCarousel").forEach((ImageCarousel) => {
//   const imageList = ImageCarousel.querySelector(".ImageCarousel__images");
//   if (imageList) {
//     const carousel = new Swiper(imageList as any, {
//       slidesPerView: "auto",
//       spaceBetween: 42,
//       a11y: {},
//       loop: false,
//       speed: 300,

//       grabCursor: true,
//     });
//   }
// });
